"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCareerStartProperty = exports.careerStartPropertyDefinition = void 0;
exports.careerStartPropertyDefinition = {
    view: {
        label: 'Career start',
        hint: 'Year in numbers',
    },
    constraints: [
        {
            name: 'max',
            argument: 2100,
        },
        {
            name: 'min',
            argument: 1700,
        },
    ],
    type: 'int',
    multiple: false,
    name: 'career-start',
};
const isCareerStartProperty = (prop) => {
    return prop.name === exports.careerStartPropertyDefinition.name;
};
exports.isCareerStartProperty = isCareerStartProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyZWVyLXN0YXJ0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY2FyZWVyLXN0YXJ0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsSUFBSSxFQUFFLGlCQUFpQjtLQUN4QjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLEtBQUs7WUFDWCxRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsS0FBSztZQUNYLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxLQUFLO0lBQ1gsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==